module.exports = __webpack_public_path__ + "static/image/service/pc/takeout.jpg?8251ab7a";